import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class MultiSelectSelectionValidator {

    /**
     * Validator to limit the number of selected items in a multiselect form control.
     * @param maxCount - Maximum number of allowed selections.
     * @returns Validator function that checks if the number of selected items exceeds the specified limit.
     */
    static maxSelectionLimit(maxCount: number): ValidatorFn | null {

        // Returns a validator function that validates the control's value.
        return (control: AbstractControl): ValidationErrors | null => {
            
            // If the control's value is defined and its length exceeds the allowed count, return a validation error.
            if (control.value && control.value.length > maxCount) {
                return { maxSelectionLimit: true };
            }

            // If the validation passes, return null.
            return null;
        };
    }
}